import { render, staticRenderFns } from "./ConfigTab.vue?vue&type=template&id=461a05db&scoped=true"
import script from "./ConfigTab.vue?vue&type=script&lang=js"
export * from "./ConfigTab.vue?vue&type=script&lang=js"
import style0 from "./ConfigTab.scss?vue&type=style&index=0&id=461a05db&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461a05db",
  null
  
)

export default component.exports